import { SyntheticEvent } from 'react';

export const getNativeEvent = <T extends Event = Event>(
    event: SyntheticEvent<Element, T> | T,
): T => ('nativeEvent' in event ? event.nativeEvent : event);
